import React from 'react';
import {t} from '@lingui/core/macro';

import MainModal from 'shared/ui/Modal/MainModal';
import IUserReport from 'features/userReports/model/UserReport/IUserReport';

import UserReportForm from './UserReportForm/UserReportForm';

interface IUserReportModalProps {
    open: boolean;
    item?: IUserReport;
    handleClose: () => void;
}

const UserReportModal: React.FC<IUserReportModalProps> = ({open, item, handleClose}) => {
    const isNew = !item;

    return (
        <MainModal
            header={isNew ? t`Создание отчёта` : t`Редактирование отчёта`}
            open={open}
            handleClose={handleClose}
            size="md"
        >
            {open && (
                <UserReportForm
                    uuid={item?.uuid}
                    onSuccess={handleClose}
                    onClose={handleClose}
                />
            )}
        </MainModal>
    );
};

export default UserReportModal;
